import React from 'react';

const Button = ({ children, onClick, className }) => {
    return (
        <button
            onClick={onClick}
            className={`bg-[#5a5657] text-white w-[88px] inline-block leading-none whitespace-nowrap border border-[#dcdfe6] border-white text-center box-border outline-none m-0 font-medium py-[12px] px-[20px] text-[14px] rounded-[4px] ${className}`}
        >
            {children}
        </button>
    );
};

export default Button;